import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-account-disable',
  standalone: false,
  template: `
        <div class="flex flex-col items-center justify-center">
        <nz-result nzStatus="error" nzTitle="Account Temporarily Disabled!">
            <div nz-result-extra>
                Your password was last updated {{ expiryDate }} days ago. Please update your password to continue.
            </div>
        </nz-result>
        <button nz-button nzType="primary" type="button" (click)="updatePassword()" class="flex items-center">
            <span>Update Password</span>
            <span nz-icon nzType="arrow-right"></span>
        </button>
    </div>
  `,
})
export class AccountDisableComponent {
  private router = inject(Router);
  private modal = inject(NzModalRef);
  expiryDate: number = 0;
  readonly modalData: { data: { expiryDate: number, loginData: any } } = inject(NZ_MODAL_DATA);
  constructor() {
    this.expiryDate = this.modalData?.data?.expiryDate || 0;
}
  updatePassword(): void {
      this.modal.destroy();
      this.router.navigate(['/auth/update-password'], { state: { loginData: this.modalData?.data?.loginData } });
  }
}
